import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
    active: {
        fontWeight: theme.typography.fontWeightBold,
        '& a ': {
            color: theme.palette.secondary.main,
        },
    },
    chevron: {
        marginTop: 0,

        '& svg': {
            marginTop: `0 !important`,
        },
    },
    clickables: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),

        '& .clickables__tel, & .clickables__mail, & .clickables__chat': {
            display: 'flex',
            alignItems: 'center',
            gap: theme.spacing(2),
            padding: theme.spacing(0.5, 2),
            borderRadius: '5px',
            backgroundColor: theme.palette.background.default,
            cursor: 'pointer',

            '&:hover': {
                '& a, & svg': {
                    color: theme.palette.secondary.main,
                },
            },

            '& a': {
                fontSize: '16px',
                color: theme.palette.text.primary,
                textDecoration: 'none',
            },

            '& svg': {
                height: theme.spacing(3),
                width: theme.spacing(3),
            },
        },
        '& .copy': {
            padding: theme.spacing(1),
            borderRadius: '50%',
            backgroundColor: theme.palette.background.default,
            height: theme.spacing(4),
            width: theme.spacing(4),
            cursor: 'pointer',

            '&:hover': {
                '& svg': {
                    color: theme.palette.secondary.main,
                },
            },
        },
    },
    collapsableBtnWrapper: {
        display: 'flex',
    },
    collapsableBtn: {
        position: 'absolute',
        right: '-10px',
        boxShadow: '2px 2px 6px rgba(0, 0, 0, 0.45)',
        backgroundColor: theme.palette.neutral[50],
        borderRadius: '5px',
        height: '24px',
        width: '24px',
        bottom: '24px',
        cursor: 'pointer',
        padding: '4px',

        '& svg': {
            height: '100%',
            width: '100%',
        },
    },
    collapseNameWrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
    },
    collapsedNav: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
        position: 'relative',
        background: theme.palette.neutral[50],
        width: theme.spacing(6),
        maxWidth: theme.spacing(6),
        height: '100%',
        paddingTop: theme.spacing(3),
        marginLeft: theme.spacing(4),
        borderRadius: theme.dimensions.borderRadiusPanel,
        boxShadow: '2px 2px 6px rgba(0, 0, 0, 0.45)',
        color: theme.palette.text.primary,
        transition: 'width 110ms cubic-bezier(0.2, 0, 0.38, 0.9)',
    },
    contact: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        fontSize: '16px',
        cursor: 'pointer',
        position: 'relative',

        '& svg': {
            height: '20px',
            width: '20px',
        },
    },
    description: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
    },
    description__text: {
        fontSize: '16px',
    },
    dialogWrapper: {
        position: 'absolute',
        bottom: theme.spacing(5),
        minWidth: '430px',
        minHeight: '200px',
        boxShadow: '2px 2px 6px rgba(0, 0, 0, 0.45)',
        borderRadius: '5px',
        backgroundColor: theme.palette.neutral[50],

        [theme.breakpoints.down(theme.breakpoints.values.xl)]: {
            maxWidth: '525px',
            left: '250px',
            bottom: 0,
            marginBottom: '20px',
        },
        [theme.breakpoints.down(theme.breakpoints.values.md)]: {
            maxWidth: '525px',
            left: '190px',
            bottom: 0,
            marginBottom: '20px',
        },
        [theme.breakpoints.up(theme.breakpoints.values.xl)]: {
            maxWidth: '525px',
            left: '250px',
            bottom: 0,
            marginBottom: '20px',
        },
        '& svg': {
            height: theme.spacing(3),
            width: theme.spacing(3),
        },

        '& .MuiDialogContent-root': {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            gap: '24px',
            padding: '24px',
        },
    },
    hide: {
        display: 'none',
    },
    link: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        fontSize: '16px',
        textDecoration: 'none',
        color: theme.palette.text.primary,
        cursor: 'pointer',

        '&:hover': {
            color: theme.palette.secondary.main,
        },

        '& svg, & span': {
            display: 'flex',
            alignItems: 'center',
            minHeight: theme.spacing(2),
        },

        '& svg': {
            height: '20px',
            width: '20px',
            marginTop: '5px',
        },

        '& span': {
            marginTop: '5px',
        },
    },
    linkElem: {
        listStyle: 'none',
        padding: theme.spacing(1, 0),
        fontWeight: theme.typography.fontWeightRegular,
        maxWidth: '173px',

        '&:first-child': {
            paddingTop: 0,
        },
    },
    linksUl: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1),
    },
    loadingIcon: {
        color: theme.palette.secondary.main,
        animation: '$spin 1s linear infinite',
    },
    navigation: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        position: 'relative',
        background: theme.palette.neutral[50],
        width: theme.spacing(30),
        maxWidth: theme.spacing(30),
        height: '100%',
        padding: theme.spacing(3),
        marginLeft: theme.spacing(4),
        borderRadius: theme.dimensions.borderRadiusPanel,
        boxShadow: '2px 2px 6px rgba(0, 0, 0, 0.45)',
        color: theme.palette.text.primary,
        transition: 'width 110ms cubic-bezier(0.2, 0, 0.38, 0.9)',

        '& .ReactCollapse--content': {
            marginLeft: theme.spacing(2),
        },
    },
    showNav: {
        display: 'flex',
    },
    subItemElem: {
        listStyle: 'none',

        '&:last-child': {
            marginBottom: theme.spacing(1),
        },
    },
    tooltip: {
        display: 'flex',
        flexWrap: 'nowrap',
        background: theme.palette.neutral[100],
        color: theme.palette.text.primary,
        borderRadius: theme.dimensions.borderRadiusInput,
        opacity: 1,
        padding: theme.spacing(0.5, 1),
        fontSize: theme.typography.size.s,

        '& .MuiTooltip-arrow': {
            top: 'unset !important',
            marginTop: `${theme.spacing(0.25)}px !important`,

            '&:before': {
                background: theme.palette.neutral[100],
            },
        },
    },
    tooltipNavToggle: {
        display: 'flex',
        flexWrap: 'nowrap',
        background: theme.palette.neutral[100],
        color: theme.palette.text.primary,
        borderRadius: theme.dimensions.borderRadiusInput,
        opacity: 1,
        padding: theme.spacing(0.5, 1),
        marginTop: theme.spacing(-1),
        fontSize: theme.typography.size.m,
    },
    udVersion: {
        display: 'flex',
        alignItems: 'center',
        opacity: 0.5,
    },
}));
